

import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';


export default class CutCopyClone  {

   isElementSelected = false;
   currentLayer = {}
   copyLayer = {}
   semaphore = false;

  constructor() {

    let scope = this;

    $(window).on('WorkArea-layer-added', function () {

      $(window).trigger('CutCopyClone-addLayerFromWorkArea');

    })

    $(window).on('WorkArea-selectCanvasElemElement',  (e, active,) => {

      this.isElementSelected = true;
      this.currentLayer = active;


    })

    $(window).on('WorkArea-deselectCanvasElem',  (e, idLayer) => {

      this.isElementSelected = false;

    })

    $(window).on('WorkArea-deselectCanvasElem',  (e, idLayer) => {

      this.isElementSelected = false;

    })




    $(document).bind("copy",  (e,id) => {

      e.preventDefault();
      if ( this.isElementSelected || id )
      {
        if ( id ) {
          this.currentLayer = bfLayers.getLayerById(id);
        }
        var idLayer =  this.currentLayer.idLayer;
        var layer = _.cloneDeep(bfLayers.getLayerById(idLayer));

        var filters = [];

        var filtersCurrent = this.currentLayer.instance.filters;
        //var filtersCurrent = bfLayers.getLayerById(idLayer).instance.filters;
        for ( var i in filtersCurrent )
        {
          var filter = filtersCurrent[i];
          for ( var j in filter )
          {
            if ( (typeof filter[j]) === 'number' )
            {

              var obj = {};
              obj['type'] = j;
              obj[j] = filter[j];
              filters.push(obj);
            }
          }
        }

        if ( layer.filters == undefined )
        {
          layer.filters = [];
        }
        _.assign(layer.filters,filters);
        if ( layer )
        {

          //layer.instance = this.currentLayer.instance;
          this.copyLayer = _.cloneDeep(layer);
          this.copyLayer.id = this.copyLayer.idLayer = -1;//new Date().getTime() + Math.random(100);
          this.copyLayer.instance.idLayer = this.copyLayer.id;
          if ( this.copyLayer.font != undefined )
          {
            this.copyLayer.type = 'text';
          }


        }
        else
        {
          //console.log('nothing to copy...');
        }
      }
    });

    $(document).bind("paste",  (e) => {
  
      //if (  this.semaphore || !this.isElementSelected ) return;
      if (  this.semaphore  ) return;

      $(window).off('CutCopyClone-addLayerFromWorkArea');
      $(window).on('CutCopyClone-addLayerFromWorkArea',()=>{
        $(window).trigger('HideLoader');

        this.semaphore = false;
        $(window).trigger('CutCopyClone-doDeselectLayers');
        $(window).trigger('Layers-selectLayer',this.copyLayer.id);
        $(window).off('CutCopyClone-addLayerFromWorkArea');

      });

      e.preventDefault();
      this.semaphore = true;

      if ( this.copyLayer )
      {
        $(window).trigger('ShowLoaderTransition');

        this.copyLayer.instance.left =  this.copyLayer.instance.left + 10;
        this.copyLayer.instance.top =  this.copyLayer.instance.top + 10;
        this.copyLayer.isCopy = true; 
        this.copyLayer.id =  this.copyLayer.idLayer =  new Date().getTime() + Math.round(Math.random()*1000);
        this.copyLayer.instance.idLayer = this.copyLayer.id;
        this.copyLayer.instance.path = this.copyLayer.path;

        $(window).trigger('Layers-addLayerToCanvas',this.copyLayer);


      }
    });

  }

}

